import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/material";
import { ThemeContextProvider, useThemeContext } from "../../contexts/ThemeContext";
import AdminHeader from "./AdminHeader";
import SettingsFab from "./SettingsFab";

// Scoped to the admin route tree only (mounted per-page, not in App.js)
// so the existing Tailwind-based supplier pages are entirely unaffected
// — MUI's ThemeProvider/CssBaseline only apply while an admin page is
// mounted, matching the same spacing/colors/theme system as the ERP
// frontend (contexts/ThemeContext.jsx ported over, see that file).
const ThemedShell = ({ children }) => {
  const { theme } = useThemeContext();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
        <AdminHeader />
        <Box component="main" sx={{ px: { xs: 2, sm: 3, md: 4 }, py: { xs: 2.5, sm: 3, md: 4 } }}>
          {children}
        </Box>
        <SettingsFab />
      </Box>
    </ThemeProvider>
  );
};

const AdminLayout = ({ children }) => (
  <ThemeContextProvider>
    <ThemedShell>{children}</ThemedShell>
  </ThemeContextProvider>
);

export default AdminLayout;
